import React from 'react';

import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import GridPagination from '~/components/Common/Elements/GridPagination';

import { customerDataFormatter, orderLinkFormatter, orderStatusFormatter, orderTotalFormatter } from '../formatters';

import AccommodationV2ItemsCell from './AccommodationV2ItemsCell';

interface Props {
  purchases: Array<App.Order>;
  total: number;
  page: number;
  sizePerPage: number;
  onPageChange: (page: number) => void;
}

const columns: Array<GridColDef> = [
  {
    field: 'fk_customer_id',
    headerName: 'Customer',
    sortable: false,
    flex: 1,
    renderCell: customerDataFormatter,
    display: 'flex',
  },
  {
    field: 'status',
    headerName: 'Order Status',
    sortable: false,
    flex: 1,
    renderCell: orderStatusFormatter,
    display: 'flex',
  },
  {
    field: 'accommodation_v2_items',
    headerName: 'Accommodation Bookings',
    sortable: false,
    flex: 2,
    renderCell: ({ row }: GridRenderCellParams<App.Order>) => <AccommodationV2ItemsCell order={row} />,
    display: 'flex',
  },
  { field: 'currency_code', headerName: 'Currency', sortable: false, display: 'flex' },
  {
    field: 'total',
    headerName: 'Order Total',
    sortable: false,
    width: 120,
    renderCell: orderTotalFormatter,
    display: 'flex',
  },
  {
    field: 'id_orders',
    headerName: 'View Order',
    sortable: false,
    width: 120,
    renderCell: orderLinkFormatter,
    display: 'flex',
  },
];

export default function AccommodationV2Page(props: Props) {
  return (
    <DataGrid
      rows={props.purchases}
      rowCount={props.total}
      columns={columns}
      pagination
      paginationMode="server"
      paginationModel={{ page: props.page - 1, pageSize: props.sizePerPage }}
      pageSizeOptions={[props.sizePerPage]}
      classes={{ root: 'T-accommodation-v2-container', virtualScrollerContent: 'T-accommodation-v2-table' }}
      slots={{ pagination: GridPagination }}
      onPaginationModelChange={({ page }) => props.onPageChange(page + 1)}
      getRowHeight={() => 'auto'}
      disableColumnFilter
      disableColumnMenu
      disableRowSelectionOnClick
      autoHeight
    />
  );
}
